<alaris-card>
	@if (tRows.length > 0 || (tRows.length === 0 && state.isFiltersApplied)) {
		<div class="table-management">
			<div class="left">
				<span class="total"> {{ totalTitle | translate }}: {{ total }} </span>
				<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-filter-vertical"></alaris-icon>
					{{ enableButtons.filters.title | translate }}
					@if (state.isFiltersApplied) {
						<div class="indicator"></div>
					}
				</button>
			</div>
			<div class="right">
				<button (click)="refresh()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
					{{ "actions.refresh_page" | translate }}
				</button>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		<alaris-table
			(filtersChange)="_applyFilter($event)"
			(sortingChange)="_applySorting($event)"
			[filters]="state.filters()"
			[dblClickRowAction]="dblClickRowAction.bind(this)"
			[dropDownRowActions]="dropDownRowActions"
			[rowActions]="rowActions"
			[tHeaders]="tHeaders()"
			[tRows]="tRows"
			[templates]="{ UserID }"
			alarisOverflowFader
		>
		</alaris-table>
	</div>
	<div class="footer">
		<alaris-pagination
			(page)="_pageChange($event)"
			[activePage]="activePage"
			[class.without-table-bar]="selection !== null && selection.length === 0"
			[hidden]="total === 0"
			[pageSizeOptions]="pageSizeOptions"
			[pageSize]="pageSize"
			[total]="total"
			class="pagination"
		>
		</alaris-pagination>
	</div>
</alaris-card>

<ng-template #UserID [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	@if (users.loading$ | async) {
		<alaris-spinner size="xs" style="transform: scale(0.5,0.5)"></alaris-spinner>
	} @else {
	    {{ users.map.get(data.UserID)?.Login || "" }}
	}
</ng-template>
